import React from 'react'
import useSWRMutation from 'swr/mutation'
import { Navigate, useNavigate } from 'react-router-dom'

import config from '../../../config'
import OnBoardingHeader from './Header'
import Button from '../../components/form/Button'
import { useI18N } from '../../../libraries/i18n/hook'
import { CurrentUserContext } from '../../../libraries/auth'
import LinkedinIcon from '../../../assets/icons/social/ln.svg?react'
import { useAnalytics, ANALYTICS_EVENTS } from '../../../libraries/posthog'
import { showLinkedinVerificationBeforeOnBoarding } from '../../../libraries/auth/linkedinVerification'
import { updateOnboardingCompleted } from '../../../api/users'

const OnboardingConnectLinkedinPage = () => {
  const { t } = useI18N()
  const { trackEvent } = useAnalytics()
  const navigate = useNavigate()
  const { isLinkedinConnected, currentUser, removeLinkedinStorage } = React.useContext(CurrentUserContext)
  const { trigger: completeOnboarding } = useSWRMutation('/users', updateOnboardingCompleted, { populateCache: true })
  const showBeforeOnBoarding = showLinkedinVerificationBeforeOnBoarding(!!currentUser?.onboardingCompleted)

  const requestLinkedinTokenUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${config.VITE_LINKEDIN_CLIENT_ID}&redirect_uri=${encodeURIComponent(config.VITE_LINKEDIN_REDIRECT_URL)}&scope=openid,profile,email`

  if(currentUser?.onboardingCompleted && isLinkedinConnected) {
    removeLinkedinStorage()
    return <Navigate to='/' replace />
  }

  const handleContinue = async () => {
    if(!showBeforeOnBoarding && isLinkedinConnected && !currentUser?.onboardingCompleted) {
      await completeOnboarding()
      trackEvent(ANALYTICS_EVENTS.ONBOARDING_COMPLETED)
      navigate('/')
    } else {
      navigate('/onboarding/personal')
    }
  }

  if (!currentUser) {
    trackEvent(ANALYTICS_EVENTS.LINKEDIN_VERIFICATION_STARTED, {user_type: 'new'})
  }

  if (currentUser?.onboardingCompleted && !isLinkedinConnected) {
    trackEvent(ANALYTICS_EVENTS.LINKEDIN_VERIFICATION_STARTED, {user_type: 'existing'})
  }

  return (
    <>
      <OnBoardingHeader title={t('onboarding.linkedin')} description={isLinkedinConnected ? t('onboarding.linkedin.connected') : t('onboarding.linkedin.description')} />
      <div className='mx-auto text-center mt-6'>
        {isLinkedinConnected
        ? <Button onClick={handleContinue}>{t('common.continue')}</Button>
        : <a href={requestLinkedinTokenUrl}><Button outlined className='flex flex-row items-center space-around'><LinkedinIcon /> {t('onboarding.linkedin.connect')}</Button></a>}
      </div>
    </>
  )
}

export default OnboardingConnectLinkedinPage
